import { ViewMain } from './Components/View'

export const ManagerStockAlmacenES = () => {

    return (
        <ViewMain />
    )
}
